import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["ref", "value"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from '@xstyled/styled-components';
import { unescape } from 'lodash';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledDiv = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  // TODO: Need to review this after MVP 1.1.0\n  // p {\n  //   margin-bottom: 0;\n  // }\n\n  // ol {\n  //   margin-bottom: 0;\n  // }\n"])));
export var TextToHTMLTransformerComponent = function TextToHTMLTransformerComponent(_ref) {
  var ref = _ref.ref,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded);

  var isEmptyText = value && (value === '<p><br></p>' || value === '<p></p>');

  if (!value || isEmptyText) {
    return null;
  }

  return /*#__PURE__*/_jsx(StyledDiv, _objectSpread({
    ref: ref,
    dangerouslySetInnerHTML: {
      __html: unescape(value)
    }
  }, rest));
};